import React, { useContext, useMemo } from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router';
import { ProfileListingSection } from '../../../components/profile/ProfileListingSection';
import { getUserListings } from '../../../services/user';
import { EUserRole } from '../../../types/db';
import { DEFAULT_LISTING_IMAGE_URL } from '../../../utilities/assets/assetHelper';
import { ROUTE_PATH } from '../../../utilities/navigation';
import { DEFAULT_CURRENCY } from '../../../utilities/currency/function';
import { UserContext } from '../../../context/UserInformation';
import { IListingItemProps } from '../../../components/listing/ListingItem/ListingItem';

interface IProfileListingsContainerProps {
    userId: string;
    userDisplayName: string;
}

export const ProfileListingsContainer = ({ userId, userDisplayName }: IProfileListingsContainerProps) => {
    const userContext = useContext(UserContext);
    const currentUserId = userContext?.user?.firebaseUser?.uid;
    const navigate = useNavigate();
    const { isLoading, isError, data } = useQuery(['Profile-Listings', userId], () => getUserListings(userId, EUserRole.HOST, false));

    const items: IListingItemProps[] = useMemo(() => {
        if (isLoading || isError || !data) return [];
        return data
            //show only the published ones or the current user in-review ones
            .filter(listing => listing.status === 'published'
                || (!!currentUserId && userId === currentUserId && listing.status === 'in-review')
            )
            //map to UI
            .map(listing => ({
                images: [listing.main_photo || listing.photos_ordered?.[0]?.url || DEFAULT_LISTING_IMAGE_URL],
                title: listing.title,
                shortDescription: listing.short_description,
                onClick: () => navigate(ROUTE_PATH.listingBuild(listing.id)),
                rating: { rate: listing.rating?.average ?? 0, numberReview: listing.rating?.quantity ?? 0 },
                // hostAvatar: listing.host.avatar_url,
                price: { amount: listing.pricing?.nightly_price?.amount ?? 0, currencyCode: listing.pricing?.nightly_price?.currency ?? DEFAULT_CURRENCY }
            }));
    }, [currentUserId, data, isError, isLoading, navigate, userId])

    if (isLoading) {
        return <ProfileListingSection loading />
    }

    if (isError || !data) {
        return null;
    }

    return <ProfileListingSection
        profileDisplayName={userDisplayName}
        items={items}
    />;
}